var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('CrudForm',_vm._b({attrs:{"customRules":_vm.customRules},on:{"submitForm":function($event){_vm.handleSubmit($event)}}},'CrudForm',_vm.form,false)),_c('v-text-field')],1)}
var staticRenderFns = []

export { render, staticRenderFns }